<template>
  <div>
    <!--<div id="gifLoader" class="loadingGif" v-show="isLoading">
      <img src="@/assets/images/load.gif" width="100" height="100" alt="Loading" />
    </div>-->
    <div class="row">
      <div class="col-6">
        <label id="choose_reporting_option">Choose a Reporting Option</label><br />
        <select v-model.number="reportOption" @change="keepData" id="DDLReportOption">
          <option value="-1">--- Select ---</option>
          <option id="completionReport" value="8">Completion Report</option>
          <option id="feedbackReport" value="9">Feedback Survey Report</option>
          <option id="groupReport" v-if="!isLifelineUser || isgroup" value="6">Group Report</option>
          <option id="memberReport" v-if="!isLifelineUser || isgroup" value="1">Member Report</option>
          <option id="productReport" v-if="!isLifelineUser || isgroup" value="3">Product Report</option>
          <option id="transcriptReport" v-if="!isLifelineUser || isgroup" value="0">Transcript Analytics</option>
          <!--<option value="2">Group Comparison Report</option>--> <!--This option is disabled on July 2024-->
          <option id="trainingReport"  value="5">Training Plan Report</option>
          <option id="usageReport" value="7">Usage Report</option>

        </select>
      </div>
      <div class="col-6 text-right">
        <button class="btn btn-secondary btn-medium" @click="doScheduledReports()" id="scheduled_reports" v-show="isLifelineUser===false">Scheduled Reports</button>
      </div>
    </div>
    <div id="dvReportFilter">

      <div class="row">
        <div class="col-7">
          <!--This option is disabled on July 2024-->
          <!--<div class="row mt-4" v-show="reportOption>0">
    <div class="col-12">
      <label>Choose Report Format</label><br />
      <input type="radio" class="checkbox" value="excel" v-model="reportFormat" />  Excel<br />
      <input type="radio" class="checkbox" value="pdf" v-model="reportFormat" :disabled="!(reportOption==1||reportOption==5||reportOption==6)" />  PDF
    </div>
  </div>-->
          <div class="row mt-4" v-show="reportOption>0">
            <div class="col-12">
              <label id="filter_by_account_status">Filter by Account Status</label><br />
              <span><input type="radio" class="checkbox" v-model="accountType" value="only_enabled" /> <span id="OnlyEnabled">Enabled Accounts Only</span><br /></span>
              <span><input type="radio" class="checkbox" v-model="accountType" value="only_disabled" /> <span id="OnlyDisabled">Disabled Accounts Only</span><br /></span>
              <span><input type="radio" class="checkbox" v-model="accountType" value="all" /> <span id="all_accounts">All Accounts</span><br /></span>
            </div>
          </div>

          <div class="row mt-4" v-show="reportOption>0">
            <div class="col-12">
              <label id="choose_date_option">Choose a Date Option</label><br />
              <input type="radio" class="checkbox" value="allTime" v-model="dateRange" /> <span id="run_for_all_dates">Run for All Dates</span>  <br />
              <input type="radio" class="checkbox" value="range" v-model="dateRange" /> <span id="run_for_specified_date_range">Run for Specified Date Range</span>
            </div>
          </div>

          <div class="row mt-4" v-show="reportOption==1||reportOption==3||reportOption==6">
            <div class="col-12">
              <label id="choose_report_type">Choose Report Type</label><br />
              <input type="radio" class="checkbox" value="summary" v-model="indivData" /> <span id="summary_data_only"> Summary Data Only</span><br />
              <input type="radio" class="checkbox" value="excel" v-model="indivData" /> <span id="summary_individual_data">Summary &amp; Individual Data</span>
            </div>
          </div>
          <!--<div class="row mt-4" v-show="reportOption==7">
    <div class="col-12">
      <label id="choose_product_option">Choose a Product Option</label><br />
      <input type="radio" class="checkbox" value="all" v-model="productOption" /> <span id="run_for_all_products">Run for All Products</span><br />
      <input type="radio" class="checkbox" value="select" v-model="productOption" /> <span id="run_for_specific_products">Run for Specific Products</span>
    </div>
  </div>-->

          <div class="row mt-4" v-show="reportOption==1">
            <div class="col-12">
              <label name="choose_report_scope">Choose Report Scope</label><br />
              <input type="radio" class="checkbox" value="all" v-model="reportScope" /> <span id="all_members">All Members</span><br />
              <input type="radio" class="checkbox" value="trainees" v-model="reportScope" /> <span id="trainees_only">Trainees Only</span><br />
              <input type="radio" class="checkbox" value="admins" v-model="reportScope" /> <span id="admins_and_data_viewers_only">Admins and Data Viewers Only</span><br />
              <input type="radio" class="checkbox" value="select" v-model="reportScope" /> <span id="selected_individual_members">Select Individual Members</span>
            </div>
          </div>



          <div class="row mt-4" v-show="reportOption==2||reportOption==6">
            <div class="col-12">
              <label name="choose_report_scope">Choose Report Scope</label><br />
              <input type="radio" class="checkbox" value="all" v-model="reportScope" /> <span id="all_groups">All Groups</span><br />
              <input type="radio" class="checkbox" value="select" v-model="reportScope" /> <span id="select_individual_groups">Select Individual Groups</span><br />
              <!--<div v-show="IsPoolAdmin===true"> <input type="radio" class="checkbox" value="selecttags" v-model="reportScope" /> <span id="select_individual_tags">Select Individual Tags</span> </div>-->
            </div>
          </div>


          <div class="row mt-4" v-show="reportOption==3&&bundles.length>0">
            <div class="col-12">
              <label id="limited_report_to_members_with_bundle">Limit Report to Members with Bundle</label><br />
              <select v-model="bundle" @change="keepBP" id="ddlBundle">
                <option v-bind:value="bdl.BundleID" v-for="bdl of bundles">{{bdl.BundleName}}</option>
              </select>
            </div>
          </div>

          <div class="row mt-4" v-show="dateRange==='range'">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label id="report_start_date">Report Start Date</label><br />
              <v-date-picker v-model="startDate" :locale="userLocale"></v-date-picker>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <label id="report_end_date">Report End Date</label><br />
              <v-date-picker v-model="endDate" :locale="userLocale"></v-date-picker>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="row mt-4" v-show="reportOption>0">
            <div class="col-12">
              <label id="receive_report">Receive Report</label><br />
              <span v-show="reportOption !== 9"><input type="radio" class="checkbox" v-model="reportType" value="immediate" /> <span id="immediate_download">Immediate Download</span><br /></span> <!--v-show="!(isLifelineUser && !isgroup)"-->
              <span v-show="hasEmail===true"><input type="radio" class="checkbox" v-model="reportType" value="reportemail" /> <span id="email">Email</span><br /></span>  <!--&& reportOption!=7 && reportOption!=8 && reportOption!=9-->
              <span v-show="hasEmail===true && isLifelineUser===false"><input type="checkbox" class="checkbox" v-model="recurring" /> <span id="on_recurring_schedule">On a Recurring Schedule</span></span>
            </div>
          </div>
          <div class="row mt-4" v-show="recurring===true">
            <div class="col-12">
              <input type="radio" class="checkbox" value="1" v-model="frequency" /> <span name="daily">Daily</span><br />
              <input type="radio" class="checkbox" value="2" v-model="frequency" /> <span name="weekly">Weekly</span><br />
              <input type="radio" class="checkbox" value="3" v-model="frequency" /> <span name="monthly">Monthly</span><br />
              <input type="radio" class="checkbox" value="4" v-model="frequency" /> <span name="quarterly">Quarterly</span><br />
              <input type="radio" class="checkbox" value="5" v-model="frequency" /> <span name="semi_annually">Semi-Annually</span><br />
              <input type="radio" class="checkbox" value="6" v-model="frequency" /> <span name="annually">Annually</span><br />
              <br />
              <span id="discontinue_scheduled_reports"> You can discontinue scheduled reports by clicking the Scheduled Reports button or Reports in the dropdown menu at the top right </span>
            </div>
          </div>

          <!--<div class="row mt-4" v-show="reportOption>0">
            <div class="col-12">
              <label id="filter_by_account_status">Filter by Account Status</label><br />
              <span><input type="radio" class="checkbox" v-model="accountType" value="all" /> <span id="all">All</span><br /></span>
              <span><input type="radio" class="checkbox" v-model="accountType" value="only_enabled" /> <span id="OnlyEnabled">Only Enabled</span><br /></span>
              <span><input type="radio" class="checkbox" v-model="accountType" value="only_disabled" /> <span id="OnlyDisabled">Only Disabled</span><br /></span>
            </div>
          </div>-->
        </div>


      </div>
      <div class="row mt-4" v-show="dateRange==='allTime' || (endDate!==null && startDate!==null)">
        <div class="col-12">
          <hr />
          <div v-if="reportOption==1" v-show="reportScope==='select'">
            <selectusers ref="optionOne" :mode="'1'" :backbutton="false"></selectusers>
          </div>
          <div v-if="reportOption==6" v-show="reportScope==='selecttags'">
            <selecttags ref="optionThree" :LicensePoolID="poolID"></selecttags>
          </div>
          <div v-if="reportOption==2" v-show="reportScope==='select'">
            <selectusers ref="optionTwo" :mode="'2'" :backbutton="false"></selectusers>
          </div>
          <div v-if="reportOption==2" v-show="reportScope==='selecttags'">
            <selecttags ref="optionFour" :LicensePoolID="poolID"></selecttags>
          </div>
          <div v-if="reportOption==3 || reportOption==9">
            <selectproducts ref="selectedProductModule" :consolidateLicenses="true" :showZeroItems="true"></selectproducts>
          </div>
          <div v-if="reportOption==4">
            <selectbundles ref="selectedBundleModule"></selectbundles>
          </div>
          <div v-if="reportOption==5">
            <selecttrainingplans ref="selectedTPModule"></selecttrainingplans>
          </div>
          <div v-if="reportOption==6" v-show="reportScope==='select'">
            <selectusers ref="optionSix" :mode="'2'" :backbutton="false"></selectusers>
          </div>
          <div v-if="reportScope!=='select'&&reportScope!=='selecttags'&&(reportOption==1||reportOption==2||reportOption==6 ||reportOption==7 ||reportOption==8)" class="text-right">
            <button class="btn btn-primary btn-short" @click="doCreateReport" name="select">Select</button>
          </div>
          <div v-if="reportOption==0&&!searchnotcomplete">
            <div class="row mt-2">
              <div class="col-12 text-right">
                <button class="btn btn-secondary btn-medium" @click="doSaveSearch" id="save_search">Save Search</button>&nbsp;&nbsp;
                <button class="btn btn-secondary btn-medium" @click="doEditSearch" id="edit_search">Edit Search</button>&nbsp;&nbsp;
                <button class="btn btn-secondary btn-medium" @click="doNewSearch" id="new_search">New Search</button>&nbsp;&nbsp;
                <button class="btn btn-secondary btn-short" @click="doTAScheduledReport" id="schedule">Schedule</button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <wondertable id="tblTranscriptResult" :wtID="'analyticsSearch'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'No Records Found'" :defaultDirection="0" ref="wt"
                             :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Transcript Results'" :burgerMenu="burgermenu" :isAdmin="isAdmin"></wondertable>
              </div>
            </div>
          </div>
          <div v-if="reportOption==0&&searchnotcomplete">
            <div class="row mt-2">
              <div class="col-12">
                <label id="search_type">Search Type</label><br />
                <input type="radio" class="checkbox" value="new" v-model="searchType" @click="resetSearch" /> <span id="new_search">New Search</span><br />
                <input type="radio" class="checkbox" value="saved" v-model="searchType" @click="resetSearch" /> <span id="use_saved_search">Use a Saved Search</span>
              </div>
            </div>
            <div class="row mt-2" v-show="searchType==='new'">
              <div class="col-12">
                <label id="product">Product</label>
                <br />
                <select v-model="aproduct" class="fullWidth" @change="doProductSelect" id="ddlProduct">
                  <option v-for="product in products" v-bind:value="product.ProductID">{{product.ProductName}}</option>
                </select>
              </div>
            </div>
            <div class="row mt-2" v-show="searchType==='saved'">
              <div class="col-12">
                <label id="saved_search">Saved Search</label><br />
                <select v-model="asearch" @change="doSavedSearchSelect" id="ddlSavedSearch">
                  <option v-for="search in searches" v-bind:value="search.AnalyticsSavedSearchID">{{search.Title}}</option>
                </select>&nbsp;&nbsp;
                <button class="btn-transparent" @click="doRemoveSavedSearch()"><font-awesome-icon size="lg" icon="times" aria-label="Remove"></font-awesome-icon></button>
              </div>
            </div>
            <div v-show="aproduct!==null&&(characters!==null||lops!==null)">
              <hr class="mt-2" />
              <div class="row mt-2">
                <div class="col-3" id="score">Score</div>
                <div class="col-4">
                  <select style="width:300px;" v-model="search.ScoreOP" id="ddlScore">
                    <option v-for="i in eqops" v-bind:value="i.value">{{i.name}}</option>
                  </select>
                </div>
                <div class="col-5">
                  <input type="text" v-model="search.Score" style="width:100px;" value="50">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3" id="when_student_started">Start Date<br />(When the student started)</div>
                <div class="col-4">
                  <!--<select style="width:300px;" v-model="search.StartDateOP">
                    <option v-for="i in eqops" v-bind:value="i.value">{{i.name}}</option>
                  </select>-->

                  <select style="width:300px;" v-model="search.StartDateOP" id="ddlStartDate">
                    <option title="Greater Than or Equal To" value="0">Greater Than or Equal To</option>
                  </select>

                </div>
                <div class="col-5">
                  <v-date-picker v-model="search.StartDate" ref="sdatepicker" reactive="true" :locale="userLocale"></v-date-picker>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3" id="finished_transcripts_only">Finish Date<br />(Finished transcripts only)</div>
                <div class="col-4">
                  <!--<select style="width:300px;" v-model="search.FinishDateOP">
                    <option v-for="i in eqops" v-bind:value="i.value">{{i.name}}</option>
                  </select>-->
                  <select style="width:300px;" v-model="search.FinishDateOP" id="ddlFinishDate">
                    <option title="Less Than or Equal To" value="0">Less Than or Equal To</option>
                  </select>
                </div>
                <div class="col-5">
                  <v-date-picker v-model="search.FinishDate" ref="fdatepicker" reactive="true" :locale="userLocale"></v-date-picker>
                </div>
              </div>


              <div class="row mt-2">
                <div class="col-12">
                  <button class="btn btn-secondary btn-medium nopadding smallheight" @click="doAdvanced"><span v-show="advanced===false" id="show">Show</span><span v-show="advanced===true" id="hide">Hide</span> <span id="advance_options">Advanced Options</span></button>
                </div>
              </div>

              <div id="advancedOptions" v-show="advanced===true">
                <hr class="mt-2" />
                <div class="row mt-2">
                  <div class="col-3" id="upto_play_number">Up to Play Number<br />(0 for all plays)</div>
                  <div class="col-9">
                    <input type="text" v-model="search.MaxPlay" style="width:100px;" />
                  </div>
                </div>
                <div class="row mt-2" v-show="characters!==null&&characters.length>0">
                  <div class="col-3" id="character">Character:</div>
                  <div class="col-9">
                    <select v-model="search.Character" style="width:300px;" id="ddlCharacter">
                      <option v-for="c in characters" v-bind:value="c.CharacterNum">{{c.CharacterName}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2" v-show="lops!==null&&lops.length>0">
                  <div class="col-3" id="level_of_play">Level Of Play:</div>
                  <div class="col-9">
                    <select v-model="search.LOP" style="width:300px;" id="ddlLOP">
                      <option v-for="l in lops" v-bind:value="l.LOPAvailable">{{l.LOPName}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-3" id="number_of_turns">Number of Turns</div>
                  <div class="col-4">
                    <select style="width:300px;" v-model="search.NumTurnsOP" id="ddlNumberOfTurns">
                      <option v-for="i in eqops" v-bind:value="i.value">{{i.name}}</option>
                    </select>
                  </div>
                  <div class="col-5">
                    <input type="text" v-model="search.NumTurns" style="width:100px;" value="0">
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-3" id="e_learning_time">E-Learning Time</div>
                  <div class="col-4">
                    <select style="width:300px;" v-model="search.ELearningTimeOP" id="ddlELearningTime">
                      <option v-for="i in eqops" v-bind:value="i.value">{{i.name}}</option>
                    </select>
                  </div>
                  <div class="col-5">
                    <input type="text" v-model="search.ELearningTime" style="width:100px;" value="0">
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-3" id="simulation_time">Simulation Time</div>
                  <div class="col-4">
                    <select style="width:300px;" v-model="search.SimulationTimeOP" id="ddlSimulationTime">
                      <option v-for="i in eqops" v-bind:value="i.value">{{i.name}}</option>
                    </select>
                  </div>
                  <div class="col-5">
                    <input type="text" v-model="search.SimulationTime" style="width:100px;" value="0">
                  </div>
                </div>
                <!--<div class="row mt-2">
                  <div class="col-3" id="device">Device</div>
                  <div class="col-9">
                    <select v-model="search.Device">
                      <option value="-1">All</option>
                      <option value="0">Desktop</option>
                      <option value="1">Tablet</option>
                      <option value="2">Phone</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-3" id="microphone_used">Microphone Used</div>
                  <div class="col-9">
                    <select v-model="search.MicrophoneUsed" style="width:300px;">
                      <option value="-1">Yes or No</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-3" id="voiceover_gender">Voiceover Gender</div>
                  <div class="col-9">
                    <select v-model="search.VoiceoverGender" style="width:300px;">
                      <option value="-1">All</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                </div>-->


              </div>
              <hr class="mt-2" />
              <div class="row mt-2" v-show="dosavesearch!==null">
                <div class="col-12">
                  <input type="checkbox" v-model="dosavesearch" /> <span id="save_this_search">Save This Search</span>
                </div>
              </div>
              <div class="row mt-2" v-show="dosavesearch===true">
                <div class="col-12">
                  <label id="search_name">Search Name</label><br />
                  <input type="text" class="fullWidth" v-model="search.Title" />
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 text-right">
                  <button class="btn btn-primary btn-short" @click="doSearch" name="search">Search</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div id="dvComingSoonmsg" style="display:none;padding-top:50px;"><b>Coming Soon.  This report is not currently available at the pool level.</b></div>
    <b-modal ref="schmodal" @ok="completeTASchedule()" id="modalCompleteTASchedule">
      <div class="row">
        <div class="col-12">
          <p id="send_this_transcript">Send this Transcript Analytics as an Excel report?</p>
          <p>
            <input type="radio" class="checkbox" value="1" v-model="bfrequency" /> <span name="daily">Daily</span><br />
            <input type="radio" class="checkbox" value="2" v-model="bfrequency" /> <span name="weekly">Weekly</span><br />
            <input type="radio" class="checkbox" value="3" v-model="bfrequency" /> <span name="monthly">Monthly</span><br />
            <input type="radio" class="checkbox" value="4" v-model="bfrequency" /> <span name="quarterly">Quarterly</span><br />
            <input type="radio" class="checkbox" value="5" v-model="bfrequency" /> <span name="semi_annually">Semi-Annually</span><br />
            <input type="radio" class="checkbox" value="6" v-model="bfrequency" /> <span name="annually">Annually</span><br />
          </p>
        </div>
      </div>
    </b-modal>
    <b-modal ref="saveSearchModal" @ok="finishSavedSearch()" id="modalSavedSearch">
      <div class="row">
        <div class="col-12">
          <span id="search_name">Search Name:</span> <input type="text" v-model:trim="search.Title" class="fullWidth" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
  label {
    font-weight: bold;
  }

  .checkbox {
    margin-left: 15px;
  }

  /*.loadingGif {
    top: 50%;
    left: 50%;
    margin-left: -32px;
    margin-top: -32px;
    position: fixed;
    z-index: 10;
  }*/
</style>

<script>
  import selectbundles from "./SelectBundles.vue"
  import selectusers from "./SelectUsers.vue"
  import selecttags from "./SelectTags.vue"
  import selectproducts from "./SelectProducts.vue"
  import selecttrainingplans from "./SelectTrainingPlans.vue"
  import wondertable from "./WonderTable.vue"

  export default {
    name: 'Reporting',
    props: ["poolID", "users", "groups", "tags", "ClientID", "isgroup", "hasEmail", "gt"],
    components: { selectusers, selecttags, selectbundles, selectproducts, selecttrainingplans, wondertable },
    data() {
      return {
        advanced: false,
        aproduct: null,
        allproducts: [],
        asearch: null,
        bundle: null,
        bundles: [],
        bundleproducts: [],
        burgermenu: [],
        characters: null,
        dosavesearch: false,
        lops: null,
        dateRange: 'allTime',
        endDate: null,
        eqops: [
          { name: "Greater Than", value: 0 },
          { name: "Greater Than or Equal To", value: 1 },
          { name: "Equal To", value: 2 },
          { name: "Less Than", value: 3 },
          { name: "Less Than or Equal To", value: 4 }
        ],
        isAdmin: false,
        IsPoolAdmin: false,
        recurring: false,
        bfrequency: 1,
        frequency: 1,
        indivData: 'summary',
        productOption: 'all',
        products: [],
        reportFormat: 'excel',
        reportOption: -1,
        reportScope: 'all',
        reportType: 'immediate',
        accountType: 'only_enabled',
        savefilters: null,
        searchType: 'new',
        search: {
          Title: '',
          ProductID: null,
          Character: -1,
          LOP: -1,
          NumTurns: 0,
          Score: 50,
          Device: -1,
          MicrophoneUsed: '-1',
          VoiceoverGender: '-1',
          FinishDate: '',
          StartDate: '',
          MaxPlay: 0,
          ELearningTime: 0,
          SimulationTime: 0,
          StartDateOP: 0,
          FinishDateOP: 0,
          ELearningTimeOP: 1,
          SimulationTimeOP: 1,
          NumTurnsOP: 1,
          ScoreOP: 1
        },
        searchnotcomplete: true,
        searches: [],
        startDate: null,
        wids: ["SessionID"],
        wtdata: null,
        wtmethods: {
          doTranscript: {
            method: function (param, ref) {
              ref.doTranscript(param);
            },
            ref: this
          }
        },
        userLocale: "en", // Default locale
        isLifelineUser: false
      }
    },
    methods: {
      clearFields() {
        this.advanced = false;
        this.aproduct = null;
        this.allproducts = [];
        this.asearch = null;
        this.dateRange = 'allTime';
        this.endDate = null;
        this.recurring = false;
        this.frequency = 1;
        this.bfrequency = 1;
        this.indivData = 'summary';
        this.productOption = 'all';
        this.reportScope = 'all';
        this.reportType = 'immediate';
        this.accountType = 'only_enabled';


        this.reportFormat = 'excel',
          this.search = {
            Title: '',
            ProductID: null,
            Character: -1,
            LOP: -1,
            NumTurns: 0,
            Score: 80,
            Device: -1,
            MicrophoneUsed: '-1',
            VoiceoverGender: '-1',
            FinishDate: '',
            StartDate: '',
            ELearningTime: 0,
            SimulationTime: 0,
            StartDateOP: 0,
            FinishDateOP: 0,
            ELearningTimeOP: 1,
            SimulationTimeOP: 1,
            NumTurnsOP: 1,
            ScoreOP: 1,
            MaxPlay: 0
          };
        this.searchnotcomplete = true;
        this.startDate = null;
        document.getElementsByClassName("loadingGif")[0].style.display = "none";
        document.getElementById("dvReportFilter").style.display = "block";
        document.getElementById("dvComingSoonmsg").style.display = "none";



      },
      completeTASchedule() {

        var cmds = [];
        var freq = this.bfrequency;

        cmds.push({
          Operation: "LicensePool",
          Function: "AddClientReport",
          Fields: {
            LicensePoolID: this.poolID,
            Parameters: JSON.stringify({
              PoolID: this.poolID,
              ProductID: this.aproduct,
              SpecialData: JSON.stringify(this.savefilters)
            }),
            ReportType: 3,
            SendNow: "false",
            Frequency: freq
          }
        });

        this.apiCommand(cmds).then(r => {
          this.popDialog(0, "Scheduled Report Has Been Set Up");
        });
      },
      configureParams() {
        const userLanguage = (() => {
          const lang = sessionStorage.getItem("userLanguage");
          return lang === "Default to English" ? "English" : lang || "English";
        })();

        var params = {
          PoolID: this.poolID,
          ClientIDs: [],
          Curricula: [],
          IndivData: this.indivData === 'summary' ? false : true,
          ReportOption: this.reportOption,
          StartTime: '0',
          EndTime: '0',
          ProductID: this.emptyguid,
          IsGroupReport: false,
          IsPDF: false,
          BundleProductID: null,
          ReportScope: this.reportScope,
          AdminGroupID: null,
          Language: userLanguage,
          Simulation: null,
          AccountType: this.accountType
        };

        if (this.dateRange !== 'allTime') {
          params.StartTime = String(new Date(this.startDate).getTime() / 1000);
          params.EndTime = String(new Date(this.endDate).getTime() / 1000);
        }

        if (this.isgroup) {
          params.AdminGroupID = this.$route.params.id;
        }

        return params;
      },
      doCreateReport() {
        var params = this.configureParams();
        if (this.reportOption == 1 || this.reportOption == 6) {
          if (this.reportFormat === 'excel') {
            this.downloadableReport("GetPoolUserStatisticsExcel", params, 0);
          }
          else {
            this.downloadableReport("GetPoolUserStatisticsPDF", params, 0);
          }
        } else if (this.reportOption == 7 || this.reportOption == 8) {
          this.downloadableReport("GetPoolUserStatisticsExcel", params, this.reportOption);
        }
        else {
          this.downloadableReport("GetGroupComparisonExcel", params, 2);
        }


      },
      doneSelection(items) {
        if (this.reportOption == 3 || this.reportOption == 9) {
          for (var pr of items) {
            var params = this.configureParams();
            params.ClientIDs = null;
            params.ProductID = pr.ProductID;
            if (this.bundle !== null && this.bundle !== this.emptyguid) {
              params.BundleProductID = this.bundleproducts.filter(p => p.bld === this.bundle)[0].bp;
            }           

            if (this.reportOption == 9) {
              //const simulations = ["988FamiliarContacts", "988ThirdParty", "988Veteran", "988LGBTQ", "988Direct"];
              //for (const sim of simulations) {
              //  params.Simulation = sim;
              //  this.downloadableReport("GetPoolUserStatisticsExcel", params, this.reportOption);
              //}
              this.downloadableReport("GetPoolUserStatisticsExcel", params, this.reportOption);
            }
            else {
              this.downloadableReport("GetPoolUserStatisticsExcel", params, 0);
            }


          }
        }
        if (this.reportOption == 5) {
          for (var tp of items) {
            var params = this.configureParams();
            params.ClientIDs = null;
            params.Curricula.push(tp.CurriculumID);
            if (this.reportFormat === 'excel') {
              this.downloadableReport("GetCurriculumStatisticsExcel", params, 1);
            }
            else {
              this.downloadableReport("GetCurriculumStatisticsPDF", params, 1);
            }
          }
        }

      },
      doAdvanced() {
        this.advanced = !this.advanced;
      },
      doEditSearch() {
        this.dosavesearch = null;
        this.searchnotcomplete = true;
        setTimeout("Window.loadLanguageContent()", 500);
      },
      doNewSearch() {
        this.search = {
          Title: '',
          ProductID: null,
          Character: -1,
          LOP: -1,
          NumTurns: 0,
          Score: 50,
          Device: -1,
          MicrophoneUsed: '-1',
          VoiceoverGender: '-1',
          FinishDate: '',
          StartDate: '',
          ELearningTime: 0,
          SimulationTime: 0,
          StartDateOP: 0,
          FinishDateOP: 0,
          ELearningTimeOP: 1,
          SimulationTimeOP: 1,
          NumTurnsOP: 1,
          ScoreOP: 1,
          MaxPlay: 0,
          AdminGroupID: null
        };
        this.aproduct = null;
        this.dosavesearch = false;
        this.searchnotcomplete = true;
        setTimeout("Window.loadLanguageContent()", 500);
      },
      doProductSelect() {
        if (this.aproduct === null) return;

        this.dosavesearch = false;
        this.search.ProductID = this.aproduct;

        this.apiCommand([
          {
            Operation: "Product",
            Function: "GetProductCharacters",
            Fields: {
              ProductID: this.aproduct
            }
          },
          {
            Operation: "Product",
            Function: "GetProductLOPs",
            Fields: {
              ProductID: this.aproduct
            }
          }]).then(r => {
            var cr = JSON.parse(r.CommandResult);
            this.characters = JSON.parse(cr.returnObjects[0].returnObject);
            this.lops = JSON.parse(cr.returnObjects[1].returnObject);
            if (this.characters.length > 0) {
              this.characters.unshift({
                CharacterName: "All",
                CharacterNum: -1
              });
            }
            if (this.lops.length > 0) {
              for (var lop of this.lops) {
                lop.LOPName = lop.LOPAvailable;
              }
              this.lops.unshift({
                LOPAvailable: -1,
                LOPName: 'All'
              });
            }
            setTimeout("Window.loadLanguageContent()", 500);
          })
      },
      doRemoveSavedSearch() {
        if (this.asearch === null) return;

        this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this saved search?', {
          title: 'Confirm Delete',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "Client",
                Function: "RemoveSavedSearch",
                Fields: {
                  SavedSearchID: this.asearch
                }
              }
            ]).then(r => {

              this.popDialog(0, "Search deleted successfully");
              this.asearch = null;
              this.aproduct = null;
              this.search = {
                Title: '',
                ProductID: null,
                Character: -1,
                LOP: -1,
                NumTurns: 0,
                Score: 50,
                Device: -1,
                MicrophoneUsed: '-1',
                VoiceoverGender: '-1',
                FinishDate: '',
                StartDate: '',
                ELearningTime: 0,
                SimulationTime: 0,
                StartDateOP: 0,
                FinishDateOP: 0,
                ELearningTimeOP: 1,
                SimulationTimeOP: 1,
                NumTurnsOP: 1,
                ScoreOP: 1,
                MaxPlay: 0,
                AdminGroupID: null
              };
              this.keepData();
            });
          }
        });
      },
      doSaveSearch() {
        this.$refs.saveSearchModal.show();
        setTimeout("Window.loadLanguageContent()", 500);
      },
      doSavedSearchSelect() {
        debugger;
        if (this.asearch === null) return;

        this.apiCommand([
          {
            Operation: "Client",
            Function: "GetSavedSearch",
            Fields: {
              SavedSearchID: this.asearch
            }
          }
        ]).then(r => {
          debugger;
          var cr = JSON.parse(r.CommandResult);
          this.search = JSON.parse(cr.returnObjects[0].returnObject);
          if (this.search.MicrophoneUsed == '1') {
            this.search.MicrophoneUsed = 'true';
          }
          else {
            this.search.MicrophoneUsed = 'false';
          }
          if (this.search.VoiceoverGender == '1') {
            this.search.VoiceoverGender = 'male';
          }
          else {
            this.search.VoiceoverGender = 'female';
          }

          try {

            if (this.search.StartDate != null) {
              var sd = new Date(this.search.StartDate);
              this.StartDate = sd.getFullYear() + "-" + (sd.getMonth() + 1) + "-" + sd.getDate();
            }

            if (this.search.FinishDate != null) {
              var fd = new Date(this.search.FinishDate);
              this.FinishDate = fd.getFullYear() + "-" + (fd.getMonth() + 1) + "-" + fd.getDate();
            }

          }
          catch (e) {
            console.log(e);
          }

          this.aproduct = this.search.ProductID;
          this.doProductSelect();
          this.dosavesearch = null;
        });
      },
      doScheduledReports() {
        this.$router.push("/client/" + this.ClientID + "/reports");
      },
      doSearch() {

        debugger;

        var eLearningOp = "", simulationOp = "", scoreOp = "", numTurnsOp = "", startDateOp = "", finishDateOp = "";

        switch (this.search.ELearningTimeOP) {
          case 0: eLearningOp = "ELearningTimeGT"; break;
          case 1: eLearningOp = "ELearningTimeGTE"; break;
          case 2: eLearningOp = "ELearningTimeEQ"; break;
          case 3: eLearningOp = "ELearningTimeLT"; break;
          case 4: eLearningOp = "ELearningTimeLTE"; break;
        }
        switch (this.search.SimulationTimeOP) {
          case 0: simulationOp = "SimulationTimeGT"; break;
          case 1: simulationOp = "SimulationTimeGTE"; break;
          case 2: simulationOp = "SimulationTimeEQ"; break;
          case 3: simulationOp = "SimulationTimeLT"; break;
          case 4: simulationOp = "SimulationTimeLTE"; break;
        }
        switch (this.search.ScoreOP) {
          case 0: scoreOp = "ScoreGT"; break;
          case 1: scoreOp = "ScoreGTE"; break;
          case 2: scoreOp = "ScoreEQ"; break;
          case 3: scoreOp = "ScoreLT"; break;
          case 4: scoreOp = "ScoreLTE"; break;
        }
        switch (this.search.NumTurnsOP) {
          case 0: numTurnsOp = "NumTurnsGT"; break;
          case 1: numTurnsOp = "NumTurnsGTE"; break;
          case 2: numTurnsOp = "NumTurnsEQ"; break;
          case 3: numTurnsOp = "NumTurnsLT"; break;
          case 4: numTurnsOp = "NumTurnsLTE"; break;
        }
        //switch (this.search.StartDateOP) {
        //  case 0: startDateOp = "StartDateGT"; break;
        //  case 1: startDateOp = "StartDateGTE"; break;
        //  case 2: startDateOp = "StartDateEQ"; break;
        //  case 3: startDateOp = "StartDateLT"; break;
        //  case 4: startDateOp = "StartDateLTE"; break;
        //}
        //switch (this.search.FinishDateOP) {
        //  case 0: finishDateOp = "FinishDateGT"; break;
        //  case 1: finishDateOp = "FinishDateGTE"; break;
        //  case 2: finishDateOp = "FinishDateEQ"; break;
        //  case 3: finishDateOp = "FinishDateLT"; break;
        //  case 4: finishDateOp = "FinishDateLTE"; break;
        //}

        startDateOp = "StartDateGTE";
        finishDateOp = "FinishDateLTE";

        var sd = '';
        try {
          if (this.search.StartDate !== null) {
            var abc = new Date(this.search.StartDate);
            sd = (abc.getMonth() + 1) + "/" + abc.getDate() + "/" + abc.getFullYear();
          }
        }
        catch (e) { }

        var fd = '';
        try {
          if (this.search.FinishDate !== null) {
            var abc = new Date(this.search.FinishDate);
            fd = (abc.getMonth() + 1) + "/" + abc.getDate() + "/" + abc.getFullYear();
          }
        }
        catch (e) { }


        var sd2 = new Date(this.search.StartDate);
        var fd2 = new Date(this.search.FinishDate);

        var filters = [
          { Key: "Device", Value: this.search.Device },
          //{ Key: "UsedSpeech", Value: this.search.MicrophoneUsed === -1 ? 'all' : this.search.MicrophoneUsed },
          //{ Key: "VoiceoverGender", Value: this.search.VoiceoverGender === -1 ? 'all' : this.search.VoiceoverGender },
          { Key: eLearningOp, Value: this.search.ELearningTime.toString() },
          { Key: simulationOp, Value: this.search.SimulationTime.toString() },
          { Key: scoreOp, Value: this.search.Score.toString() },
          { Key: numTurnsOp, Value: this.search.NumTurns.toString() },
          //{ Key: startDateOp, Value: sd == "" ? sd2.getFullYear() + "-" + (sd2.getMonth() + 1) + "-" + sd2.getDate() : sd },
          //{ Key: finishDateOp, Value: fd == "" ? fd2.getFullYear() + "-" + (fd2.getMonth() + 1) + "-" + fd2.getDate() : fd },
          { Key: startDateOp, Value: sd },
          { Key: finishDateOp, Value: fd },
          { Key: "MaxPlay", Value: typeof (this.search.MaxPlay) === "undefined" ? 0 : this.search.MaxPlay }
        ];

        if (this.characters.length > 0) {
          filters.push({ Key: "Character", Value: this.search.Character === -1 ? '-' : this.getCharacter(this.search.Character) })
        }

        if (this.lops.length > 0) {
          filters.push({ Key: "LOP", Value: this.search.LOP === -1 ? '-' : this.search.LOP })
        }

        if (this.isgroup) {
          filters.push({ Key: "AdminGroupID", Value: this.$route.params.id })
        }

        this.savefilters = filters;

        var cmds = [{
          Operation: "Session",
          Function: "Query",
          Fields: {
            LicensePoolID: this.poolID,
            ProductID: this.aproduct,
            Filters: JSON.stringify(filters)
          }
        }];

        if (this.dosavesearch === true) {
          cmds.push({
            Operation: "Client",
            Function: "AddSavedSearch",
            Fields: this.search
          })
        }

        this.apiCommand(cmds).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.wtdata = JSON.parse(cr.returnObjects[0].returnObject);
          this.searchnotcomplete = false;

          setTimeout("Window.loadLanguageContent()", 500);
        })


      },
      downloadableReport(url, rpdata, rptype) {
        try {

          document.getElementsByClassName("loadingGif")[0].style.display = "block";


          if (this.isgroup && (rpdata.ClientIDs === null || rpdata.ClientIDs.length === 0)) {
            rpdata.ClientIDs = [];
            if (rpdata.ReportScope == "all") {
              rpdata.ReportScope = "select";
            }
            for (var user of this.users) {
              rpdata.ClientIDs.push(user.ClientID);
            }
          }

          if (this.recurring === true || this.reportType !== 'immediate') {
            var freq = 0;
            if (this.recurring === true) {
              freq = this.frequency;
            }

            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "AddClientReport",
                Fields: {
                  LicensePoolID: this.poolID,
                  Parameters: JSON.stringify(rpdata),
                  ReportType: rptype,
                  SendNow: this.reportType !== 'immediate' ? "true" : "false",
                  Frequency: freq
                }
              }
            ])
              .then(r => {
                this.finishReport();
              })
              .catch(err => {
                console.error("Error in apiCommand (AddClientReport):", err);
                self.popDialog(1, "This report could not be created because it exceeds the maximum data size. Please adjust your filters and try again.");
                document.getElementsByClassName("loadingGif")[0].style.display = "none";
              });

          } else {
            var self = this;
            var postData = {
              PoolID: this.poolID,
              _SearchData: JSON.stringify(rpdata)
            };

            var req = new XMLHttpRequest();
            req.open("POST", this.$hostname + "/Streamable.svc/" + url, true);
            req.responseType = "blob";
            req.setRequestHeader("Content-type", "application/json");
            req.onload = function () {
              var blob = req.response;
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = req.getResponseHeader("Content-Disposition").replace("attachment; filename=", "");
              document.body.appendChild(link);
              link.click();
              link.remove();
              self.finishReport();
            };
            req.onerror = function (err) {
              console.error("Error while downloading Excel Report:", err);
              self.popDialog(1, "This report could not be created because it exceeds the maximum data size. Please adjust your filters and try again.");
              document.getElementsByClassName("loadingGif")[0].style.display = "none";
            };
            req.send(JSON.stringify(postData));
          }
        } catch (err) {
          console.error("Error while downloading Excel Report:", err);
          self.popDialog(1, "This report could not be created because it exceeds the maximum data size. Please adjust your filters and try again.");
          document.getElementsByClassName("loadingGif")[0].style.display = "none";
        }
      },

      doTAScheduledReport() {
        this.$refs["schmodal"].show();
        setTimeout("Window.loadLanguageContent()", 500);

      },
      doTranscript(params) {
        window.open(this.$hostname + "/Streamable.svc/GetTranscriptPDF?SessionID=" + params.SessionID);
      },
      finishReport() {
        if (this.reportType === 'immediate') {
          this.popDialog(2, "Request submitted - If the report does not download within 2 minutes, please try the email option.");
        }
        else {
          if (this.recurring == true) {
            this.popDialog(0, "Scheduled Report Has Been Set Up");
          }
          else {
            this.popDialog(0, "Request submitted - It may take up to 90 minutes for the report to be sent to your email.");
          }
        }

        document.getElementsByClassName("loadingGif")[0].style.display = "none";
      },
      finishSavedSearch() {
        if (this.search.Title.length === 0) {
          return;
        }
        this.apiCommand([
          {
            Operation: "Client",
            Function: "AddSavedSearch",
            Fields: this.search
          }]).then(r => {
            this.popDialog(0, "Search Saved");
          });
      },
      getCharacter(ch) {
        var chs = this.characters.filter(p => p.CharacterNum === ch);
        if (chs.length > 0) {
          return chs[0].CharacterName;
        }
        return "-";
      },
      groupsSelected() {
        var params = this.configureParams();

        if (this.reportOption == 6) {
          var cmds = [];
          this.$refs["optionThree"].getData().then(taggroups => {

            var usegroups = this.reportScope === 'select' ? this.$refs["optionSix"].getData() : taggroups;

            for (var group of usegroups) {
              cmds.push({
                Operation: "LicensePool",
                Function: "GetGroupUsersAndSubUsers",
                Fields: {
                  LicensePoolID: this.poolID,
                  GroupID: group.value
                }
              })
            }

            this.apiCommand(cmds).then(r => {
              var cr = JSON.parse(r.CommandResult);
              for (var x = 0; x < cr.returnObjects.length; x++) {
                for (var gu of JSON.parse(cr.returnObjects[x].returnObject)) {
                  if (params.ClientIDs.filter(p => p === gu.ClientID).length === 0) {
                    params.ClientIDs.push(gu.ClientID);
                  }
                }
              }

              if (this.reportFormat === 'excel') {
                this.downloadableReport("GetPoolUserStatisticsExcel", params, 0);
              }
              else {
                this.downloadableReport("GetPoolUserStatisticsPDF", params, 0);
              }

            });
          })


        }

        if (this.reportOption == 2) {

          this.$refs["optionFour"].getData().then(taggroups => {

            var usegroups = this.reportScope === 'select' ? this.$refs["optionTwo"].getData() : taggroups;
            for (var group of usegroups) {
              params.ClientIDs.push(group.value);
            }
            this.downloadableReport("GetGroupComparisonExcel", params, 2);

          });
        }

      },
      keepBP() {
        var filteredProducts = [];
        if (this.bundle === null || this.bundle === this.emptyguid) {
          filteredProducts = this.allproducts;
        }
        else {
          for (var bpr of this.bundleproducts.filter(p => p.bld === this.bundle)) {
            var pr = this.allproducts.filter(q => q.ProductID === bpr.pr);
            if (pr.length > 0) {
              filteredProducts.push(pr[0]);
            }
          }
        }

        this.$refs["selectedProductModule"].setData(filteredProducts);

      },
      keepData() {
        this.clearFields();


        //if (this.isLifelineUser==true){
        //    //alert(this.reportOption);
        //    if (!this.isgroup)
        //    {
        //      if (this.reportOption == 1||this.reportOption == 3||this.reportOption == 6) {
        //        document.getElementById("dvReportFilter").style.display = "none";
        //        document.getElementById("dvComingSoonmsg").style.display = "block";
        //      }
        //    }
        //  }

       

        // Lifeline default
        if (this.isLifelineUser === true) {
          this.reportType = 'reportemail';
        }

        // ✅ Force override for specific reports
        if (this.reportOption === 7 || this.reportOption === 8) {
          this.reportType = 'immediate';
          this.recurring = false;
        }
        if (this.isLifelineUser === true) {

          if (this.reportOption == 1 || this.reportOption == 3 || this.reportOption == 6) {
            this.reportType = "immediate";
          }
        }

        if (this.reportOption == 1) {
          var self = this;
          window.setTimeout(function () {
            self.$refs["optionOne"].setData("Select Members", [], self.users, [], self.groups);
            self.$refs["optionOne"].switchToUsers();
            self.$forceUpdate();

            Window.loadLanguageContent();
          }, 200);
        }

        if (this.reportOption == 6) {
          var self = this;
          window.setTimeout(function () {
            self.$refs["optionSix"].setData("Select Groups", [], self.users, [], self.groups);
            self.$refs["optionSix"].switchToGroups();
            self.$refs["optionThree"].setData(self.tags);
            self.$forceUpdate();
          }, 200);

        }

        if (this.reportOption == 2) {
          var self = this;
          window.setTimeout(function () {
            self.$refs["optionTwo"].setData("Select Groups", null, null, [], self.groups);
            self.$refs["optionTwo"].switchToGroups();
            self.$refs["optionFour"].setData(self.tags);
            self.$forceUpdate();
          }, 200);

        }
        if (this.reportOption == 3 || this.reportOption == 9) {
          this.apiCommand([{
            Operation: "LicensePool",
            Function: "GetProducts",
            Fields: {
              LicensePoolID: this.poolID,
              LanguageID: sessionStorage.getItem("userLanguageID")
            }
          }, {
            Operation: "LicensePool",
            Function: "GetBundles",
            Fields: {
              LicensePoolID: this.poolID
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetBundleProducts",
            Fields: {
              LicensePoolID: this.poolID
            }
          }]).then(r => {
            var cr = JSON.parse(r.CommandResult);
            if (this.isLifelineUser === true) {
              this.allproducts = JSON.parse(cr.returnObjects[0].returnObject)
                .filter(p => !p.ProductName.includes(": Archived Product") &&
                  !p.ProductName.includes(" Skill Builder") && !p.ProductName.includes("Conversaciones de crisis") && !p.ProductName.includes("Lifeline Veteran Archive: Safety Assessment Only") && !p.ProductName.includes("Veterans Crisis Line"));

            }
            else {
              this.allproducts = JSON.parse(cr.returnObjects[0].returnObject);

            }

            var bps = JSON.parse(cr.returnObjects[2].returnObject);
           
            for (var bundle of JSON.parse(cr.returnObjects[1].returnObject)) {
              this.bundles.push(bundle);
              for (var bp of bundle.BundleProducts) {
                this.bundleproducts.push({ bld: bundle.BundleID, bp: bp.BundleProductID, pr: bp.ProductID });
                if (this.allproducts.filter(p => p.ProductID === bp.ProductID).length === 0) {
                  var tbp = bps.filter(p => p.ProductID === bp.ProductID);
                  if (tbp.length > 0) {
                    this.allproducts.push({
                      LicensePoolProductID: bp.BundleProductID,
                      ProductID: bp.ProductID,
                      ProductName: tbp[0].ProductName,
                      LicenseType: 4,
                      LicensesNumber: 1
                    });
                  }
                }
              }
            }
            if (this.bundles.length > 0) {
              this.bundles.unshift({
                BundleID: this.emptyguid,
                BundleName: "--- Select ---"
              });
              this.bundle = this.emptyguid;
            }

            this.$refs["selectedProductModule"].setData(this.allproducts);

          });
        }

        if (this.reportOption != 0 && this.isLifelineUser == true) {
          this.dateRange = 'range';
        }


        if (this.reportOption == 5) {
          this.apiCommand([{
            Operation: "LicensePool",
            Function: "GetCurricula",
            Fields: {
              LicensePoolID: this.poolID
            }
          }]).then(r => {
            var cr = JSON.parse(r.CommandResult);
            this.$refs["selectedTPModule"].setData(JSON.parse(cr.returnObjects[0].returnObject));

          });
        }

        if (this.reportOption == 0) {
          this.apiCommand([{
            Operation: "LicensePool",
            Function: "GetProducts",
            Fields: {
              LicensePoolID: this.poolID,
              IncludeChildren: "true",
              NoDuplicates: "true",
              IncludeBundles: "true",
              LanguageID: sessionStorage.getItem("userLanguageID")
            }
          },
          {
            Operation: "Client",
            Function: "GetAllSavedSearches",
            Fields: {
              ClientID: this.ClientID
            }
          }
          ]).then(r => {
            var cr = JSON.parse(r.CommandResult);
            this.products = JSON.parse(cr.returnObjects[0].returnObject);
            this.products.unshift({
              ProductID: null,
              ProductName: "--- Select ---"
            });
            this.searches = JSON.parse(cr.returnObjects[1].returnObject);
            this.searches.unshift({
              AnalyticsSavedSearchID: null,
              Title: "--- Select ---"
            });

          });
        }

        const userLanguage = sessionStorage.getItem("userLanguage");
        if (userLanguage) {
          this.userLocale = userLanguage === "Espanol" ? "es" : "en"; // Default to English if not "Espanol"
        }

        setTimeout("Window.loadLanguageContent()", 500);
      },
      resetSearch() {
        this.aproduct = null;
        this.asearch = null;
        this.keepData();
      },
      usersSelected() {
        var params = this.configureParams();

        if (this.reportOption == 1) {
          if (this.reportScope === "select") {

            for (var cl of this.$refs["optionOne"].getData()) {
              params.ClientIDs.push(cl.value);
            }

            if (this.reportFormat === 'excel') {
              this.downloadableReport("GetPoolUserStatisticsExcel", params, 0);
            }
            else {
              this.downloadableReport("GetPoolUserStatisticsPDF", params, 0);
            }
          }
          else {

          }

        }

      }
    },
    mounted() {
      if (sessionStorage.getItem("isLifelineUser") == 'true') {
        this.isLifelineUser = true;
      }

      if (this.isLifelineUser == false) {
        document.getElementById("usageReport").remove();
        document.getElementById("completionReport").remove();
        document.getElementById("feedbackReport").remove();

      } else {
        document.getElementById("completionReport").innerText = "Completion Report - New!";
        document.getElementById("feedbackReport").innerText = "Feedback Survey Report - New!";
        document.getElementById("usageReport").innerText = "Usage Report - New!";
        document.getElementById("transcriptReport").innerText = "Transcript Analytics - Updated";

        if (this.isgroup) {
          document.getElementById("groupReport").innerText = "Group Report - Updated";
          document.getElementById("memberReport").innerText = "Member Report - Updated";
          document.getElementById("productReport").innerText = "Product Report - Updated";
          document.getElementById("trainingReport").innerText = "Training Plan Report - Updated";
        } else {
          document.getElementById("groupReport").innerText = "Group Report - Coming Soon";
          document.getElementById("memberReport").innerText = "Member Report - Coming Soon";
          document.getElementById("productReport").innerText = "Product Report - Coming Soon";
          document.getElementById("trainingReport").innerText = "Training Plan Report - Coming Soon";
        }

        document.querySelector('input[type="radio"][value="allTime"]').remove();
        document.getElementById("run_for_all_dates").remove();
      }

      //This option is disabled on July 2024
      this.apiCommand([{
        Operation: "LicensePool",
        Function: "GetCurricula",
        Fields: {
          LicensePoolID: this.poolID
        }
      }]).then(r => {
        var cr = JSON.parse(r.CommandResult);
        if (JSON.parse(cr.returnObjects[0].returnObject).length == 0) {
          document.getElementById("trainingReport").remove();
        }

      });
      //----------------------------

      if (typeof (this.gt) !== "undefined" && this.gt !== null) {
        if (this.gt === "tp") {
          this.reportOption = 5;
          this.keepData();
        }
      }

      setTimeout("Window.loadLanguageContent()", 500);

      //alert("hi");

      var sdata = localStorage.getItem("sdata");
      if (sdata != null) {
        if (JSON.parse(sdata).allpools.length > 0) {
          this.IsPoolAdmin = true;
        }
      }
    }
  }
</script>
